import { Trans, useTranslation } from 'react-i18next';

export default function Slogan() {
  const { t } = useTranslation();
  return (
    <section className="home__slogan">
      <p>
        <Trans
          i18nKey="home.slogan"
          components={{
            green: <span style={{ color: '#32cd32', fontWeight: '500' }} />,
          }}
        />
      </p>
    </section>
  );
}
